import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "./designcss/gallery.css";

const ImageGrid = () => {
  const [columnSize, setColumnSize] = useState("50%"); // Default: 2 columns
  const [activeButton, setActiveButton] = useState(2);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    const fetchProject = async () => {
      setLoading(true);
      try {

                                // http://localhost:8000
                                // https://albiemer.onrender.com
        const response = await fetch(`https://albiemer.onrender.com/api/get_projects/?page=${page}`);
        if (!response.ok) throw new Error("Failed to fetch data");

        const result = await response.json();
        
        // Ensure we only set non-empty, valid data
        if (Array.isArray(result) && result.length > 0) {
          setData(result);
        } else {
          setData([]); // Set empty if no records exist
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setData([]); // Prevent broken images on error
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [page]);

  const setGridColumns = (size, buttonIndex) => {
    setColumnSize(size);
    setActiveButton(buttonIndex);
  };

  const copyImageLink = (url) => {
    // Use the Clipboard API to copy the image URL
    navigator.clipboard.writeText(url).then(() => {
      alert("Image URL copied to clipboard!");
    }).catch((error) => {
      console.error("Failed to copy:", error);
    });
  };

  return (
    <div>
      <div className="header">
        <h1>My Works</h1>
        <button className={`btn ${activeButton === 1 ? "active" : ""}`} onClick={() => setGridColumns("100%", 1)}>1</button>
        <button className={`btn ${activeButton === 2 ? "active" : ""}`} onClick={() => setGridColumns("50%", 2)}>2</button>
        <button className={`btn ${activeButton === 4 ? "active" : ""}`} onClick={() => setGridColumns("25%", 4)}>4</button>
        <button className="Addnew">
          <Link to="/createnewproj">+</Link>
        </button>
        <p>Click on the buttons to change the grid view.</p>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : data.length === 0 ? ( 
        <p>No projects available yet.</p> 
      ) : (
        <div className="row" style={{ display: "flex" }}>
          {data.slice().reverse().map((item, index) => (
            <div key={index} className="column" style={{ flex: columnSize, padding: "5px" }}>
              {item.src ? (
                <div>
                    <img src={item.src} alt={`Grid ${index + 1}`} style={{ width: "100%" }} loading="lazy" />
                  <button onClick={() => copyImageLink(item.src)} className="projoptbutton">Copy Image Link</button>
                </div>
              ) : (
                <p>No image available</p>
              )}

              {item.youtube && (
                <a href={item.youtube} target="_blank" rel="noopener noreferrer" >
                  <button className="projoptbutton">YouTube</button>
                </a>
              )}

              {item.link && (
                <Link to={`/${item.link.replace('/project', '')}`}>
                <button className="projoptbutton">Repository</button>
              </Link>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageGrid;
